'use strict';

const dynamicFormAppEl = '.dynamic-form-app';

const createDynamicForms = () => {
    document.querySelectorAll(dynamicFormAppEl).forEach(el => {
        renderDynamicForm(el);
    });
};

const renderDynamicForm = (el) => {
    const Vue = require('vue');
    const DynamicForm = require('./dynamic-form/dynamic-form.vue');

    return new Vue({
        el: el,
        components: {
            DynamicForm
        }
    });
};

const shouldInit = () => {
    return document.querySelectorAll(dynamicFormAppEl).length > 0;
};

const dynamicFormApp = {
    init: () => {
        if (shouldInit()) {
            createDynamicForms();
        }
    }
};

module.exports = dynamicFormApp;
